import { useCallback, useEffect, useState } from "react";
import IntroPage from "./pages/IntroPage";
import GamePage from "./pages/GamePage";

type Route = "/" | "/game";

const getRouteFromHash = (): Route => {
  return window.location.hash === "#/game" ? "/game" : "/";
};

export default function App() {
  const [route, setRoute] = useState<Route>(() => getRouteFromHash());

  useEffect(() => {
    const syncRoute = () => setRoute(getRouteFromHash());
    window.addEventListener("hashchange", syncRoute);
    return () => window.removeEventListener("hashchange", syncRoute);
  }, []);

  const navigate = useCallback((next: Route) => {
    const targetHash = next === "/" ? "#/" : "#/game";
    if (window.location.hash !== targetHash) {
      window.location.hash = targetHash;
      setRoute(next);
    } else {
      setRoute(next);
    }
  }, []);

  if (route === "/game") {
    return <GamePage />;
  }

  return <IntroPage onStart={() => navigate("/game")} />;
}
